import { useState, useEffect } from 'react';

import { useCheckoutContext } from '@zooplus/checkout-state';
import { Anchor } from '@zooplus/ui-components';

import useCartTracking from '@hooks/use-adobe-tracking/use-cart-tracking';
import { useTranslation } from '@hooks/use-translations';
import { CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';
import { restoreArticle } from '@utilities/restore-article';
import { isObjectNotNullOrEmpty, getSearchParams } from '@utilities/utils';

const RestoreArticle = () => {
  const { t } = useTranslation();
  const {
    setSavingsPlanArticle,
    setArticleQuantity,
    prevArticle,
    setPrevArticle,
    mainTogglesMap = {},
    cartVersion,
  } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const { trackReAddArticleEvent } = useCartTracking();

  const [id, setArticleId] = useState<string | number | null>();
  const [isSp, setIsSP] = useState<string | boolean | null>();
  const [offerIds, setOfferIds] = useState<string[] | null>();

  const isNewOverviewPage = mainTogglesMap.CHECKOUT_FRONTEND_NEW_OVERVIEW_PAGE;

  useEffect(() => {
    if (isNewOverviewPage && isObjectNotNullOrEmpty(prevArticle)) {
      setArticleId((prevArticle as { articleId: number })?.articleId);
      setIsSP((prevArticle as { isSp: boolean })?.isSp);
      setOfferIds((prevArticle as { offerIds: string[] })?.offerIds);
    } else {
      setArticleId(getSearchParams(window.location.href).get('articleId'));
      setIsSP(getSearchParams(window.location.href).get('isSp'));
      setOfferIds(getSearchParams(window.location.href).get('offerIds')?.split(','));
    }
  }, [isNewOverviewPage, prevArticle]);

  const restoreItem = () => {
    restoreArticle(
      {
        setSavingsPlanArticle,
        setArticleQuantity,
      },
      trackReAddArticleEvent,
      isSp,
      id,
      offerIds,
      cartVersion,
    );
    setPrevArticle?.({});
  };

  return (
    <Anchor
      variant="neutral"
      isBold={true}
      data-testid="re-add-article-btn"
      onClick={() => restoreItem()}>
      {t('cart.undo.remove.item.button')}
    </Anchor>
  );
};

export default RestoreArticle;
